"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = {
  actions: {
    flexDirection: 'column',
    paddingLeft: 20,
    paddingRight: 20
  },
  name: {
    width: '49%',
    marginRight: '2%'
  },
  initials: {
    width: '49%'
  },
  saveButton: {
    color: 'white',
    background: '#536881',
    marginBottom: 10,
    '&:hover': {
      background: '#435871'
    }
  },
  dontSaveButton: {
    color: 'white',
    background: '#ff0000',
    marginBottom: 10,
    '&:hover': {
      background: '#df0000'
    }
  },
  bold: {
    fontWeight: 'bold'
  },
  italic: {
    fontStyle: 'italic'
  }
};

var SaveSignature = /*#__PURE__*/function (_Component) {
  _inherits(SaveSignature, _Component);

  function SaveSignature() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SaveSignature);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SaveSignature)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      enteredInitials: '',
      enteredName: '',
      isInitialsError: false,
      isNameError: false,
      isSignatureSaved: false
    });

    _defineProperty(_assertThisInitialized(_this), "getIsSignatureSaved", function () {
      var _this$props$me$data = _this.props.me.data;
      _this$props$me$data = _this$props$me$data === void 0 ? {} : _this$props$me$data;
      var token = _this$props$me$data.signature_session; // If no token then API call has not yet resolved so don't ask user yet.

      if (!token) return false; // Get the isSignature saved token/value pair. If not present, ask user.

      var savedTokenAndValue = window.sessionStorage.getItem('isSignatureSaved');
      if (!savedTokenAndValue) return null; // Check the token is for the right session. If it is, return saved value.

      var _savedTokenAndValue$s = savedTokenAndValue.split('-'),
          _savedTokenAndValue$s2 = _slicedToArray(_savedTokenAndValue$s, 2),
          savedToken = _savedTokenAndValue$s2[0],
          savedValue = _savedTokenAndValue$s2[1];

      if (savedToken === token) return savedValue === 'true'; // Token is for wrong session, return null.

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "setIsSignatureSaved", function (isSignatureSaved) {
      var _this$props = _this.props,
          _this$props$me$data2 = _this$props.me.data;
      _this$props$me$data2 = _this$props$me$data2 === void 0 ? {} : _this$props$me$data2;
      var token = _this$props$me$data2.signature_session,
          onSaveSignature = _this$props.onSaveSignature;
      var tokenAndValue = "".concat(token, "-").concat(!!isSignatureSaved);
      window.sessionStorage.setItem('isSignatureSaved', tokenAndValue);

      _this.setState({
        isSignatureSaved: isSignatureSaved
      }, function () {
        return onSaveSignature(isSignatureSaved);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateName", function (ev) {
      var enteredName = ev.target.value;

      _this.setState({
        enteredName: enteredName,
        isNameError: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateInitials", function (ev) {
      var enteredInitials = ev.target.value;

      _this.setState({
        enteredInitials: enteredInitials,
        isInitialsError: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "saveNoSignature", function () {
      _this.setIsSignatureSaved(false);
    });

    _defineProperty(_assertThisInitialized(_this), "saveSignature", function () {
      var _this$props$actor = _this.props.actor;
      _this$props$actor = _this$props$actor === void 0 ? {} : _this$props$actor;
      var recordedName = _this$props$actor.name,
          recordedInitials = _this$props$actor.initials;
      var isError = false;

      _this.setState(function (_ref) {
        var enteredName = _ref.enteredName,
            enteredInitials = _ref.enteredInitials;
        var isNameError = enteredName.toLowerCase().trim() !== recordedName.toLowerCase().trim();
        var isInitialsError = enteredInitials.toLowerCase().trim() !== recordedInitials.toLowerCase().trim();
        isError = isNameError || isInitialsError;
        return {
          isInitialsError: isInitialsError,
          isNameError: isNameError
        };
      }, function () {
        if (!isError) _this.setIsSignatureSaved(true);
      });
    });

    return _this;
  }

  _createClass(SaveSignature, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onSaveSignature = this.props.onSaveSignature;
      var isSignatureSaved = this.getIsSignatureSaved();
      this.setState({
        isSignatureSaved: isSignatureSaved
      }, function () {
        return onSaveSignature(isSignatureSaved);
      });
    } // Returns true if signature is saved.
    // Returns false if signature is not saved.
    // Returns null if user must be asked whether or not to save signature.

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          actor = _this$props2.actor,
          classes = _this$props2.classes,
          documents = _this$props2.documents;
      var _this$state = this.state,
          enteredInitials = _this$state.enteredInitials,
          enteredName = _this$state.enteredName,
          isInitialsError = _this$state.isInitialsError,
          isNameError = _this$state.isNameError,
          isSignatureSaved = _this$state.isSignatureSaved;
      var offerRequiresValidatedSignature = documents.some(function (_ref2) {
        var fields = _ref2.fields;
        return fields.some(function (_ref3) {
          var isValidated = _ref3._derived.isValidated;
          return isValidated;
        });
      });
      var isDialogOpen = isSignatureSaved == null && offerRequiresValidatedSignature;
      var isDisabled = !(enteredInitials.trim() && enteredName.trim());
      return _react.default.createElement(_core.Dialog, {
        open: isDialogOpen,
        "aria-labelledby": "save-signature-dialog-title",
        disableBackdropClick: true,
        disableEscapeKeyDown: true
      }, _react.default.createElement(_core.DialogTitle, {
        id: "save-signature-dialog-title",
        "data-test-id": "SaveSignature-title"
      }, "Save Signature & Initials"), _react.default.createElement(_core.DialogContent, null, _react.default.createElement(_core.DialogContentText, null, "We can save your signature for the duration of our online session. If you choose to save your signature you will not be asked to type your signature again until you log out or close your browser.", _react.default.createElement("br", null), _react.default.createElement("span", {
        className: classes.bold
      }, "PLEASE NOTE"), ' ', _react.default.createElement("span", {
        className: classes.italic
      }, "the exception will be that employees and I-9 verifiers must type their signatures directly on the form to comply with federal I-9 regulations.")), _react.default.createElement(_core.TextField, {
        className: classes.name,
        autoFocus: true,
        margin: "dense",
        label: "Full Legal Name",
        type: "text",
        value: enteredName,
        onChange: this.updateName,
        error: isNameError,
        inputProps: {
          'data-test-id': 'SaveSignature-name'
        },
        helperText: isNameError && _react.default.createElement("span", {
          "data-test-id": "SaveSignature-nameError"
        }, "Please enter your full legal name as recorded in Start+:", _react.default.createElement("br", null), actor.name)
      }), _react.default.createElement(_core.TextField, {
        className: classes.initials,
        margin: "dense",
        label: "Initials",
        type: "text",
        value: enteredInitials,
        onChange: this.updateInitials,
        error: isInitialsError,
        inputProps: {
          'data-test-id': 'SaveSignature-initials'
        },
        helperText: isInitialsError && _react.default.createElement("span", {
          "data-test-id": "SaveSignature-initialsError"
        }, "Please enter your initials as recorded in Start+:", _react.default.createElement("br", null), actor.initials)
      })), _react.default.createElement(_core.DialogActions, {
        className: classes.actions
      }, _react.default.createElement(_core.Button, {
        onClick: this.saveSignature,
        className: classes.saveButton,
        variant: "contained",
        disabled: isDisabled,
        fullWidth: true,
        "data-test-id": "SaveSignature-save"
      }, "Yes, save for the duration of my session"), _react.default.createElement(_core.Button, {
        onClick: this.saveNoSignature,
        className: classes.dontSaveButton,
        variant: "contained",
        fullWidth: true,
        "data-test-id": "SaveSignature-dontSave"
      }, "No, don't save anything and don't ask me again this session"), _react.default.createElement(_core.Typography, {
        variant: "caption"
      }, "Only the person associated with these records is permitted to use this system through this account. Completion and submission of the online forms available through this system will create legally binding obligations associated with each form. Please read each form carefully. Execution of each form will be accomplished through clicking on the \u201CSign Here\u201D button, where required on the form. By clicking \u201CSign Here\u201D, you are acknowledging that you have read the applicable form, understand the requirements for submission of the information, agree that the information you are submitting is complete and accurate information, and that the form can be submitted and signed by you through this system.")));
    }
  }]);

  return SaveSignature;
}(_react.Component);

var _default = (0, _styles.withStyles)(styles)(SaveSignature);

exports.default = _default;